import { render, staticRenderFns } from "./MultipleConsentedModal.vue?vue&type=template&id=4177f04a&lang=pug"
import script from "./MultipleConsentedModal.vue?vue&type=script&lang=ts"
export * from "./MultipleConsentedModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports